export const KIND_MARKET = 'market'
export const KIND_LIFE_INSURANCE = 'lifeinsurance'
export const KIND_CAPITALISATION = 'capitalisation'
export const KIND_PEA = 'pea'
export const KIND_SAVINGS = 'savings'
export const KIND_PEE = 'pee'
export const KIND_PERCO = 'perco'
export const KIND_PERP = 'perp'
export const KIND_PER = 'per'
export const KIND_MADELIN = 'madelin'
export const KIND_ARTICLE83 = 'article83'
export const KIND_RSP = 'rsp'
export const KIND_CHECKING = 'checking'
export const KIND_CARD = 'card'
export const KIND_DEPOSIT = 'deposit'